
const fillZero = (value: number) =>{
  return ('0' + value).slice(-2);
}

export const getHours = () => {
  const hours = [];
  let hour = 0;
  while(hour < 24) {
    hours.push({
      label: fillZero(hour) + '时',
      value: fillZero(hour)
    });
    hour += 1;
  }
  return hours;
}

export const getMinutes = () =>{
  const minutes = [];
  let minute = 0;
  while(minute < 60) {
    minutes.push({
      label: fillZero(minute) + '分',
      value: fillZero(minute)
    });
    minute += 1;
  }
  return minutes;
}

